module.exports = __webpack_public_path__ + "img/curse_katie_bell.b1036431.jpg";